import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F5F8FC', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #DDE7F1', padding: '16px 0', display: 'flex', justifyContent: 'center' }}>
        <span style={{ fontSize: '22px', fontWeight: '700', color: '#2D87F0' }}>Quoteplicity</span>
      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', padding: '80px 16px 40px' }}>
        <div className="portal-card" style={{ width: '100%', maxWidth: '420px', padding: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>Forgot Password</h2>
          <p style={{ color: '#64748B', fontSize: '14px', marginBottom: '20px' }}>Enter your email address and we'll send you a reset link.</p>
          {sent ? (
            <div className="alert-success">
              <i className="fas fa-check-circle mr-2"></i>
              If that email is registered, you'll receive a reset link shortly.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <input className="input-field" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email address" required style={{ marginBottom: '16px' }} />
              <button type="submit" className="btn-primary" style={{ width: '100%', height: '42px' }}>Send Reset Link</button>
            </form>
          )}
          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <button onClick={() => navigate('/login')} style={{ background: 'none', border: 'none', color: '#2D87F0', cursor: 'pointer', fontSize: '13px' }}>← Back to login</button>
          </div>
        </div>
      </div>
    </div>
  );
}
